"use strict";
/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO
// Get rid of the damn anys
Object.defineProperty(exports, "__esModule", { value: true });
exports.recursiveRenderSubmission = exports.renderSubmission = void 0;
const dotty = require("dotty");
const util = require("util");
function renderSubmission(propertySchema, submission, subsectionSchema, language = 'en') {
    propertySchema = dotty.get(propertySchema, subsectionSchema.propertyAccessor);
    const renderedSubmission = recursiveRenderSubmission(propertySchema, (submission === null || submission === void 0 ? void 0 : submission.data) || {}, subsectionSchema.dataAccessor, (subsectionSchema === null || subsectionSchema === void 0 ? void 0 : subsectionSchema.raw) || false, language);
    return renderedSubmission;
}
exports.renderSubmission = renderSubmission;
function recursiveRenderSubmission(propertySchema, data, dataAccessor, raw, language = 'en') {
    var _a, _b, _c;
    let rawData = dotty.get(data, dataAccessor);
    if (raw) {
        if (rawData == null)
            return undefined;
        return rawData;
    }
    if (Array.isArray(rawData)) {
        return rawData
            .map((_, i) => recursiveRenderSubmission(propertySchema, data, dataAccessor.concat([i.toString()]), raw, language))
            .join(', ');
    }
    if (dataAccessor.includes('items')) {
        return renderArrayData(propertySchema, dataAccessor, data, !!raw, language);
    }
    if (rawData === null || rawData === void 0 ? void 0 : rawData.url) {
        return rawData.url;
    }
    if (!rawData) {
        return undefined;
    }
    if (dataAccessor &&
        dataAccessor.length &&
        dataAccessor[dataAccessor.length - 1] === 'date') {
        rawData = rawData && (rawData === null || rawData === void 0 ? void 0 : rawData.substring(0, rawData === null || rawData === void 0 ? void 0 : rawData.indexOf('T'))); // TODO might be more reliable to do `(new Date(rawData)).toString()`
    }
    const localized = ((_b = (_a = propertySchema === null || propertySchema === void 0 ? void 0 : propertySchema['value_localization']) === null || _a === void 0 ? void 0 : _a[language]) === null || _b === void 0 ? void 0 : _b[rawData]) ||
        ((_c = propertySchema === null || propertySchema === void 0 ? void 0 : propertySchema['value_localization']) === null || _c === void 0 ? void 0 : _c[rawData]);
    const isString = typeof rawData === 'string';
    const result = localized ||
        (isString && rawData) ||
        (propertySchema &&
            util.inspect(rawData) !== 'undefined' &&
            util.inspect(rawData) !== '{}' &&
            util.inspect(rawData)) ||
        undefined;
    return result;
}
exports.recursiveRenderSubmission = recursiveRenderSubmission;
// This is a hacky way of turning an array of items into their parts
// Find where the array starts. Then, replace the "items" key with an array accessor. Then, iterate over the returned array
function renderArrayData(propertySchema, dataAccessor, data, raw, language = 'en') {
    const indexOfItems = dataAccessor.indexOf('items');
    const arrayAccessor = dataAccessor.slice(0, indexOfItems);
    const itemAccessor = dataAccessor.slice(indexOfItems + 1) || [];
    const items = dotty.get(data, arrayAccessor);
    let localizedList;
    if (Array.isArray(items)) {
        localizedList = items.map((_, i) => recursiveRenderSubmission(propertySchema, data, arrayAccessor.concat([i.toString(), ...itemAccessor]), raw, language));
    }
    else if (typeof items === 'object' && items !== null) {
        localizedList = Object.keys(items).map((_, i) => recursiveRenderSubmission(propertySchema, data, arrayAccessor.concat([i.toString(), ...itemAccessor]), raw, language));
    }
    else if (!(typeof items === 'string')) {
        return util.inspect(localizedList);
    }
    else if (typeof items === 'string') {
        return items;
    }
    else {
        return undefined;
    }
    return localizedList.join(', ');
}
//# sourceMappingURL=renderSubmission.js.map